module.exports = __webpack_public_path__ + "2478428cd8ef268d640043a098fa7cb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/img/landing/cheque_innovacion1.jpg
// module id = 339
// module chunks = 1